<div class="claims-page">
  @if (searchForm) {
    <div class="claims-page__filter-shell">
      <form class="claims-filter-card" [formGroup]="searchForm">
        <div class="claims-filter-card__header">
          <div class="claims-filter-card__title-block">
            <span class="claims-filter-card__eyebrow font-walter">
              {{ 'crm.pages.claims.claims.filtri' | translate }}
            </span>
            <h3 class="claims-filter-card__title">
              {{ 'crm.pages.claims.claims.reclami' | translate }}
            </h3>
          </div>
        </div>

        <div class="claims-filter-card__content">
          <div class="claims-filter-card__grid claims-filter-card__grid--filters">
            <app-input
              [label]="'generics.cols.name' | translate"
              formControlName="customer"
              type="text"
            ></app-input>

            <app-input
              [label]="'generics.cols.orderName' | translate"
              formControlName="orderName"
              type="text"
            ></app-input>

            <app-input
              [label]="'generics.cols.state' | translate"
              formControlName="state"
              type="selection"
              [selectionOptions]="stateSelection"
            ></app-input>

            <app-input
              [label]="'generics.cols.commRef' | translate"
              formControlName="commRef"
              type="text"
            ></app-input>
          </div>
        </div>

        <div class="claims-filter-card__footer">
          <button
            type="button"
            class="claims-filter-card__btn claims-filter-card__btn--primary force-text-white"
            (click)="doSearch()"
          >
            <span>{{ 'generics.cols.search' | translate }}</span>
          </button>

          <button
            type="button"
            class="claims-filter-card__btn claims-filter-card__btn--secondary"
            (click)="clearFilter()"
          >
            <i class="icon-ipe-clear" aria-hidden="true"></i>
            <span>{{ 'generics.cols.clean' | translate }}</span>
          </button>
        </div>
      </form>
    </div>
  }

  @if (claims) {
    <div class="claims-page__table-shell">
      <app-tree
        [dataSource]="claims"
        [columns]="['code', 'customer', 'orderName', 'productName', 'stateLabel', 'commRef']"
        [actions]="actions"
      ></app-tree>
    </div>
  }
</div>
